import { MAX_INT_VALUE } from '../../constants/maxValues';

export const isValidMaxNumber = (value: number) => {
  return value <= MAX_INT_VALUE;
};
